export default "__VITE_ASSET__C086E6V1__"